<template lang="html">
  <div class="prt-icon-chart">
    <div class="pb-container" />
    <prt-icon :icon="icon" :width="22" :height="22"/>
  </div>
</template>

<script>
import * as ProgressBar from 'progressbar.js';
import PrtIcon from './PrtIcon.vue';

export default {
  components: {
    PrtIcon,
  },
  data() {
    return {
      progressbar: false,
    };
  },
  mounted() {
    this.progressbar = new ProgressBar.Circle(this.$el.querySelector('.pb-container'), {
      strokeWidth: 10,
      color: '#5FB984',
      trailColor: '#D0D9D3',
      ease: 'easeInOut',
    });
    this.progressbar.path.style.strokeLinecap = 'round';
    this.progressbar.animate(this.value, { duration: 200 });
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.progressbar.animate(newVal, { duration: 200 });
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-icon-chart
    margin: 32px 16px
    display: inline-block
    width: 48px
    height: @width
    position: relative

    .pb-container
      transform: rotate(180deg)

    .prt-icon
      position: absolute
      color: positive
      top: 13px
      left: @top

</style>
